import { defineMessages } from 'react-intl';

const scope = 'app.containers.admin.AccountManagement.Alerts';

export default defineMessages({
    title: {
        id: `${scope}.title`,
        defaultMessage: 'Alerts',
    },
    description: {
        id: `${scope}.description`,
        defaultMessage: 'These properties have missing data - click the row for more information',
    },
    descriptionIndividualProperty: {
        id: `${scope}.descriptionIndividualProperty`,
        defaultMessage: 'This property has missing data - click the row for more information',
    },
    name: {
        id: `${scope}.name`,
        defaultMessage: 'Property',
    },
    sellingRates: {
        id: `${scope}.sellingRates`,
        defaultMessage: 'Selling Rates',
    },
    derived: {
        id: `${scope}.derived`,
        defaultMessage: 'Derived',
    },
    roomRatePriceLimits: {
        id: `${scope}.roomRatePriceLimits`,
        defaultMessage: 'Hurdle/Rack Rates',
    },
    roomRatePriceLimitsDefault: {
        id: `${scope}.roomRatePriceLimitsDefault`,
        defaultMessage: 'Default Hurdle/Rack Rates',
    },
    backToList: {
        id: `${scope}.backToList`,
        defaultMessage: '<< Back To List',
    },
    sellingRateText: {
        id: `${scope}.sellingRateText`,
        defaultMessage: 'The following dates are missing selling rates',
    },
    derivedText: {
        id: `${scope}.derivedText`,
        defaultMessage: 'The following dates are missing derived room configuration',
    },
    rrplText: {
        id: `${scope}.rrplText`,
        defaultMessage: 'The following room types and dates are missing hurdle/rack rates',
    },
    rrplDefaultText: {
        id: `${scope}.rrplDefaultText`,
        defaultMessage: 'The following room types are missing default hurdle/rack rates',
    },
});
